import type { SimplePaletteColorOptions } from "@mui/material";
export const Colors = {
	Primary: "#00C0AA",
	Primary75: "#52D4C5",
	Primary50: "#7ADED3",
	Primary25: "#A3E8E0",
	Primary10: "#CCF2EE",
	Primary300: "#E7F6FC",

	Secondary: "#009CEA",
	Secondary75: "#52BCF1",
	Secondary50: "#7ACCF4",
	Secondary25: "#A3DBF7",
	Secondary10: "#CCEBFB",

	Success: "#90CC11",
	Success75: "#B4DC5D",
	Success50: "#C5E483",
	Success25: "#D7EDA9",

	Warning: "#FACC15",
	Warning75: "#FCDC60",
	Warning50: "#FCE485",
	Warning25: "#FDEDAB",

	Danger: "#E01A49",
	Danger75: "#EA6383",
	Danger50: "#EF88A0",
	Danger25: "#F4ADBD",

	MonoChrome50: "#F8FAFC",
	MonoChrome100: "#F1F5F9",
	MonoChrome200: "#E2E8F0",
	MonoChrome300: "#CBD5E1",
	MonoChrome400: "#94A3B8",
	MonoChrome500: "#64748B",
	MonoChrome600: "#475569",
	MonoChrome700: "#334155",
	MonoChrome800: "#1E293B",

	White: "#FFFFFF",

	Black: "#0F172A",
	Black75: "#5D6370",
	Black50: "#838891",
	Black25: "#838891",

	DarkGrey: "#1D1F20",

	Pink: "#E174C2",
	Pink75: "#E790CE",
	Pink50: "#EDACDA",
	Pink25: "#F3C7E7",

	Grey: "#878787",
	Grey75: "#9F9F9F",
	Grey50: "#B7B7B7",
	Grey25: "#CFCFCF",

	Yellow: "#E4BD00",
	Yellow75: "#E9CA33",
	Yellow50: "#EFD766",
	Yellow25: "#F4E599",

	Orange: "#F97316",
	Orange75: "#FBA061",
	Orange50: "#FCB686",
	Orange25: "#FDCDAB",

	Blue: "#3565DC",
	Blue75: "#5D84E3",
	Blue50: "#86A3EA",
	Blue25: "#AEC1F1",

	Purple: "#A855F7",
	Purple75: "#C48BFA",
	Purple50: "#D2A7FB",
	Purple25: "#E0C2FC",

	Teal: "#0286C0",
	Teal75: "#359ECD",
	Teal50: "#67B6D9",
	Teal25: "#9ACFE6",

	Gold: "#CAB642",
	Gold75: "#C9B764",
	Gold50: "#D6C98B",
	Gold25: "#E4DBB1",

	Magenta: "#FF168A",
	Magenta75: "#FF45A1",
	Magenta50: "#FF73B9",
	Magenta25: "#FFA2D0",

	Comodities: "#CAB642",
	Comodities75: "#C9B764",
	Comodities50: "#D6C98B",
	Comodities25: "#E4DBB1",

	Paper: "#F7F9FC",
	Label: "#233145",
	PaidAdvisory: "#ff0084",
	ResizeHandle: "#3B82F6",
};

export const DarkModeColors = {
	Primary: "#00C0AA",
	Primary75: "#52D4C5",
	Primary50: "#7ADED3",
	Primary25: "#A3E8E0",
	Primary10: "#CCF2EE",
	Primary300: "#E7F6FC",

	Secondary: "#009CEA",
	Secondary75: "#52BCF1",
	Secondary50: "#7ACCF4",
	Secondary25: "#A3DBF7",
	Secondary10: "#CCEBFB",

	Success: "#90CC11",
	Success75: "#B4DC5D",
	Success50: "#C5E483",
	Success25: "#D7EDA9",

	Warning: "#FACC15",
	Warning75: "#FCDC60",
	Warning50: "#FCE485",
	Warning25: "#FDEDAB",

	Danger: "#E01A49",
	Danger75: "#EA6383",
	Danger50: "#EF88A0",
	Danger25: "#F4ADBD",

	MonoChrome50: "#1E293B",
	MonoChrome100: "#334155",
	MonoChrome200: "#475569",
	MonoChrome300: "#64748B",
	MonoChrome400: "#94A3B8",
	MonoChrome500: "#CBD5E1",
	MonoChrome600: "#E2E8F0",
	MonoChrome700: "#F1F5F9",
	MonoChrome800: "#F8FAFC",

	White: "#0F172A",

	Black: "#FFFFFF",
	Black75: "#5D6370",
	Black50: "#838891",
	Black25: "#838891",

	DarkGrey: "#1D1F20",

	Pink: "#E174C2",
	Pink75: "#E790CE",
	Pink50: "#EDACDA",
	Pink25: "#F3C7E7",

	Grey: "#878787",
	Grey75: "#9F9F9F",
	Grey50: "#B7B7B7",
	Grey25: "#CFCFCF",

	Yellow: "#E4BD00",
	Yellow75: "#E9CA33",
	Yellow50: "#EFD766",
	Yellow25: "#F4E599",

	Orange: "#F97316",
	Orange75: "#FBA061",
	Orange50: "#FCB686",
	Orange25: "#FDCDAB",

	Blue: "#3565DC",
	Blue75: "#5D84E3",
	Blue50: "#86A3EA",
	Blue25: "#AEC1F1",

	Purple: "#A855F7",
	Purple75: "#C48BFA",
	Purple50: "#D2A7FB",
	Purple25: "#E0C2FC",

	Teal: "#0286C0",
	Teal75: "#359ECD",
	Teal50: "#67B6D9",
	Teal25: "#9ACFE6",

	Gold: "#CAB642",
	Gold75: "#C9B764",
	Gold50: "#D6C98B",
	Gold25: "#E4DBB1",

	Magenta: "#FF168A",
	Magenta75: "#FF45A1",
	Magenta50: "#FF73B9",
	Magenta25: "#FFA2D0",

	Comodities: "#CAB642",
	Comodities75: "#C9B764",
	Comodities50: "#D6C98B",
	Comodities25: "#E4DBB1",

	Paper: "#F7F9FC",
	Label: "#233145",
	PaidAdvisory: "#ff0084",
	ResizeHandle: "#3B82F6",
};

export type HspThemeColors = typeof Colors & {
	hspColor?: string;
	hspColor75?: string;
	hspColor25?: string;
};

interface PropsColorOverrides {
	comodities: true;
	orange: true;
	dismiss: true;
	default: true;
}

interface PropsBadgeColorOverrides {
	transparent: true;
}

type ThemeExtendedProps = {
	colors: {
		border: {
			main: string;
			hover: string;
			active: string;
		};
		placeholder: string;
	};
	shadow: {
		primary: string;
		primaryHover: string;
	};
	transition: {
		fast: string;
		slow: string;
	};
	borderRadius: string;
	vh: (value: number) => string;
	timeline: {
		height: {
			small: string;
			medium: string;
			large: string;
		};
	};
};

interface TextDarkModeViabaleOptions {
	white: string;
	black: string;
}

declare module "@mui/material" {
	interface ButtonPropsColorOverrides extends PropsColorOverrides {}
	interface IconButtonPropsColorOverrides extends PropsColorOverrides {}
	interface CheckboxPropsColorOverrides extends PropsColorOverrides {}
	interface ChipPropsColorOverrides extends PropsColorOverrides {}
	interface BadgePropsColorOverrides extends PropsBadgeColorOverrides {}
	interface PaletteOptions {
		comodities: PaletteOptions["primary"];
		blue: PaletteOptions["primary"];
		pink: PaletteOptions["primary"];
		orange: PaletteOptions["primary"];
		purple: PaletteOptions["primary"];
		magenta: PaletteOptions["primary"];
		greyHalf: PaletteOptions["primary"];
		greyLight: PaletteOptions["primary"];
		paidAdvisory: PaletteOptions["primary"];
		primaryGreen: PaletteOptions["primary"];
		paper: PaletteOptions["primary"];
		dismiss: PaletteOptions["primary"];
		darkGrey: PaletteOptions["primary"];
		default: PaletteOptions["primary"];
		myPLANN: MyPlannPaletteOptions;
		darkmodeText: TextDarkModeViabaleOptions;
	}

	export interface MyPlannPaletteOptions {
		main: string;
		main75: string;
		main50: string;
		main25: string;
		main10: string;
	}

	interface Palette {
		comodities: SimplePaletteColorOptions;
		blue: SimplePaletteColorOptions;
		pink: SimplePaletteColorOptions;
		orange: SimplePaletteColorOptions;
		purple: SimplePaletteColorOptions;
		magenta: SimplePaletteColorOptions;
		greyHalf: SimplePaletteColorOptions;
		greyLight: SimplePaletteColorOptions;
		primaryGreen: SimplePaletteColorOptions;
		paidAdvisory: SimplePaletteColorOptions;
		paper: SimplePaletteColorOptions;
		dismiss: SimplePaletteColorOptions;
		darkGrey: SimplePaletteColorOptions;
		default: SimplePaletteColorOptions;
		myPLANN: MyPlannPaletteOptions;
		darkmodeText: TextDarkModeViabaleOptions;
	}
	interface ThemeOptions extends ThemeExtendedProps {}
}

declare module "@mui/material/styles" {
	interface TypographyVariants {
		subtitle3: React.CSSProperties;
		filter: React.CSSProperties;
	}
	interface TypographyVariantsOptions {
		subtitle3?: React.CSSProperties;
		filter: React.CSSProperties;
	}
	interface Theme extends ThemeExtendedProps {}
}

declare module "@mui/material/Typography" {
	interface TypographyPropsVariantOverrides {
		subtitle3: true;
		filter: true;
	}
}
